import React from "react";
import { Box, Typography, Menu, MenuItem } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

const updateLocalStorage = (key, updates) => {
  const existingSettings = JSON.parse(localStorage.getItem(key) || "{}");
  const updatedSettings = {
    ...existingSettings,
    ...updates,
  };
  localStorage.setItem(key, JSON.stringify(updatedSettings));
};

const ModelSelector = ({ currentModel, models, onModelChange, serviceMode = "chat" }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const localStorageKey = `scribe-${serviceMode}-options`;

  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event) => {
    event?.stopPropagation();
    setAnchorEl(null);
  };

  const handleMenuItemClick = (model) => {
    onModelChange(model);
    updateLocalStorage(localStorageKey, {
      options: {
        model,
      },
    });
    setAnchorEl(null);
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      sx={{
        backgroundColor: "#3c3f44",
        borderRadius: 1,
        padding: "6px 12px",
        cursor: "pointer",
        userSelect: "none",
      }}
      onClick={handleClick}
    >
      <Typography variant="body2" color="white" sx={{ marginRight: 1 }}>
        Model: {models.find((m) => m.value === currentModel)?.label || "Select Model"}
      </Typography>
      <ArrowDropDownIcon sx={{ color: "white" }} />
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        sx={{
          "& .MuiPaper-root": {
            backgroundColor: "#3c3f44",
            color: "white",
            borderRadius: 1,
          },
        }}
      >
        {models.map((model) => (
          <MenuItem
            key={model.value}
            onClick={() => handleMenuItemClick(model.value)}
            sx={{
              "&:hover": { backgroundColor: "#565a5e" },
            }}
          >
            {model.label}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default ModelSelector;